/* mw-accordion — blocks/accordion.liquid. Light DOM, progressive enhancement only.

   Every row is a native <details>/<summary> written by the server, so opening, closing, the
   keyboard and the announced expanded state all work with this file blocked or still loading.
   The script adds exactly two things:

   - «Open one row at a time». Where the browser has the exclusive accordion (<details name>) it
     just names the group, and the browser does the closing — including the close transition.
     Where it does not, a toggle listener closes the siblings.
   - Theme editor: selecting a row (or a block inside one) opens that row, so the merchant sees
     what they clicked. The state is left as the merchant leaves it.

   Nothing here measures or animates: the open and close are a CSS transition on
   ::details-content (assets/accordion.css), which the reduced-motion guard turns off. */

const NATIVE_EXCLUSIVE = 'name' in HTMLDetailsElement.prototype;
let groupCount = 0;

class MwAccordion extends HTMLElement {
  connectedCallback() {
    this.abort = new AbortController();
    const { signal } = this.abort;

    if (this.hasAttribute('data-single-open')) {
      if (NATIVE_EXCLUSIVE) {
        groupCount += 1;
        this.groupName = `mw-accordion-${groupCount}`;
        this.rows().forEach((details) => {
          details.name = this.groupName;
        });
      } else {
        this.addEventListener('toggle', (event) => this.closeSiblings(event), { capture: true, signal });
      }
    }

    if (window.Shopify?.designMode) {
      ['shopify:block:select'].forEach((type) =>
        document.addEventListener(
          type,
          (event) => {
            if (!(event.target instanceof Element) || !this.contains(event.target)) return;
            const details = event.target.closest('.accordion-row__details') || event.target.querySelector('.accordion-row__details');
            if (details) details.open = true;
          },
          { signal }
        )
      );
    }
  }

  disconnectedCallback() {
    this.abort?.abort();
  }

  rows() {
    return [...this.querySelectorAll('.accordion-row__details')].filter(
      (details) => details.closest('mw-accordion') === this
    );
  }

  closeSiblings(event) {
    const opened = event.target;
    if (!(opened instanceof HTMLDetailsElement) || !opened.open) return;
    this.rows().forEach((details) => {
      if (details !== opened) details.open = false;
    });
  }
}

if (!customElements.get('mw-accordion')) customElements.define('mw-accordion', MwAccordion);

export { MwAccordion };
